import Immutable from 'immutable';
import {
  RawSheetVersion,
  SheetVersion,
  SheetVersionList,
} from './SheetVersion';

export type SheetId = string;

export interface RawSheet {
  sheetid: SheetId; // This is the sheet's number (e.g. A1.00), not a uuid
  sheetNumber: string;
  versions: RawSheetVersion[];
}

export interface SheetData {
  sheetid: SheetId; // This is the sheet's number (e.g. A1.00), not a uuid
  sheetNumber: string;
  versions: SheetVersionList;
}

const defaultValues: SheetData = {
  sheetid: '',
  sheetNumber: '',
  versions: Immutable.List(),
};

export const SheetFactory = Immutable.Record(defaultValues, 'Sheet');

export class Sheet extends SheetFactory {
  serialize(): RawSheet {
    return this.toJS();
  }

  static deserialize(rawSheet: RawSheet): Sheet {
    return new Sheet({
      ...rawSheet,
      // NOTE: Might be a good place to sort the versions.
      versions: Immutable.List<SheetVersion>(
        rawSheet.versions.map(SheetVersion.deserialize)
      ),
    });
  }
}

export type SheetList = Immutable.List<Sheet>;

// SheetMap's keys are the sheet's number (e.g. A1.00) and not an uuid as one would expect. "SheetId" is confusing...
export type SheetMap = Immutable.OrderedMap<SheetId, Sheet>;
